(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/start/assets/react/components/play-buttons.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/start/assets/react/components/play-buttons.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const productMapping = svs.numbergames.productMapping;
const rowPrice = svs.numbergames.rules.EUROJACKPOT.rowPrice;
const playPackages = svs.eurojackpot.data.cms.playPackages;
const PlayButtons = () => {
  const sortedPlayPackages = [...playPackages].sort((a, b) => a.rows - b.rows);
  const handleClick = (numberOfRows, price) => {
    svs.components.analytics.trackEvent({
      category: 'eurojackpot_startPage',
      action: 'CTA_predefined',
      opt_label: "".concat(numberOfRows, " rader"),
      opt_value: price
    }, () => {
      svs.utils.url.navigate("/eurojackpot/spela?rader=".concat(numberOfRows, "&dag=n"));
    });
  };
  const _svs$numbergames$draw = svs.numbergames.draws.drawsUtils.sortProductsByDrawTime(productMapping.CONSTANTS.EUROJACKPOT),
    _svs$numbergames$draw2 = _slicedToArray(_svs$numbergames$draw, 1),
    firstDraw = _svs$numbergames$draw2[0];
  const date = new Date(firstDraw.regCloseTime);
  let day;
  switch (true) {
    case dateFns.isToday(date):
      day = 'idag';
      break;
    case dateFns.isTomorrow(date):
      day = 'imorgon';
      break;
    default:
      day = productMapping.getDay(firstDraw === null || firstDraw === void 0 ? void 0 : firstDraw.productItsId).toLowerCase();
  }
  const drawTitle = "Dragning ".concat(day);
  return React.createElement("div", {
    className: "eurojackpot-play-buttons-wrapper"
  }, React.createElement("div", {
    className: "eurojackpot-play-buttons"
  }, React.createElement("h2", {
    className: "eurojackpot-play-buttons-title"
  }, drawTitle), React.createElement("div", {
    className: "eurojackpot-play-buttons-grid"
  }, sortedPlayPackages.map((_ref, i) => {
    let rows = _ref.rows;
    const price = rows * rowPrice;
    return React.createElement("button", {
      className: "eurojackpot-play-button"
      ,
      key: i,
      onClick: () => handleClick(rows, price),
      type: "button"
    }, React.createElement("p", {
      className: "button-title"
    }, "".concat(rows, " rader")), React.createElement("h3", {
      className: "button-price"
    }, "".concat(price, " kr")));
  }))));
};
setGlobal('svs.eurojackpot.react.components', {
  PlayButtons
});

 })(window);